/*
 * This function takes two arrays, and based on a provided function (the predicate)
 * will combine the arrays, removing items that meet the conditional
 *
 * arrayOne: First array to merge (If both arrays share the same item, this array will be prioritized)
 * arrayTwo: Second array to merge
 * predicate: Function that will determine if two items are the same
 */
export const mergeArraysRemovingDuplicates = ({
  arrayOne,
  arrayTwo,
  predicate = (a, b) => a === b,
}) => {
  const c = [...arrayOne] // copy to avoid side effects
  // add all items from B to copy C if they're not already present
  arrayTwo.forEach(bItem =>
    c.some(cItem => predicate(bItem, cItem)) ? null : c.push(bItem),
  )
  return c
}
